var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProtiva3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-141"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "57.09 370.11 185.2 370.11 189.32 288.82 52.97 288.82 57.09 370.11",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.81,326H63l-1.55-28.22H177.62ZM63.94,325H174.87l1.69-26.22H62.49Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.28,358.5h-108L65,333H175.87Zm-107.1-1H173.34L174.81,334H66Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.37,315H108.46l-.88-6.81h25.67Zm-23-1H131.5l.62-4.81h-23.4Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.37,349.16H108.46l-.88-6.8h25.67Zm-23-1H131.5l.62-4.8h-23.4Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.86 370.11 73.62 378.96 71.11 396.76 66.22 396.76 66.22 370.11 74.86 370.11",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.86 370.11 73.62 378.96 66.22 378.96 66.22 370.11 74.86 370.11",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.44 370.11 168.68 378.96 171.18 396.76 176.07 396.76 176.07 370.11 167.44 370.11",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.44 370.11 168.68 378.96 176.07 378.96 176.07 370.11 167.44 370.11",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.12,
    y: 52.17,
    width: 47.22,
    height: 64.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.66,
    y: 52.17,
    width: 47.22,
    height: 64.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.12,
    y: 122.41,
    width: 47.22,
    height: 64.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.66,
    y: 122.41,
    width: 47.22,
    height: 64.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.53,
    y: 52.17,
    width: 47.22,
    height: 64.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.07,
    y: 52.17,
    width: 47.22,
    height: 64.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.53,
    y: 122.41,
    width: 47.22,
    height: 64.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.07,
    y: 122.41,
    width: 47.22,
    height: 64.92,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-141"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 421.62,
    cy: 457.18,
    rx: 46.34,
    ry: 10.9,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.98,
    cy: 428.8,
    rx: 160.74,
    ry: 20.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.2,
    cy: 454.8,
    rx: 160.74,
    ry: 20.21,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-141"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "47.44 396.76 98.08 396.51 148.72 396.43 250 396.26 351.28 396.43 401.92 396.51 452.56 396.76 401.92 397 351.28 397.09 250 397.26 148.72 397.09 98.08 397 47.44 396.76",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-141"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 151.35,
    cy: 131.74,
    r: 99.04,
    transform: "translate(-0.7 262.66) rotate(-81.77)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.88,
    cy: 133.94,
    r: 94.5,
    transform: "translate(15.11 283.68) rotate(-87.44)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.88,
    cy: 133.94,
    r: 88.53,
    transform: "translate(13.66 282.31) rotate(-86.88)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.41,115.15c-40.32,24.43-106.58,64.5-143.61,86.47a88.6,88.6,0,0,1-24.19-32.53L197.09,55.57A88.63,88.63,0,0,1,242.41,115.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.35,137a87.76,87.76,0,0,1-5.85,28.77L128.08,218a87.12,87.12,0,0,1-13.94-6C147.49,192.75,208.44,157.68,244.35,137Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.03,
    y: 51.84,
    width: 1.71,
    height: 13.42,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.33,
    y: 61.94,
    width: 1.71,
    height: 13.42,
    transform: "translate(-18.49 68.28) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.73,
    y: 89.53,
    width: 1.71,
    height: 13.42,
    transform: "translate(-38.06 126.56) rotate(-60)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.78,
    y: 133.09,
    width: 13.42,
    height: 1.71,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.88,
    y: 170.78,
    width: 13.42,
    height: 1.71,
    transform: "translate(-73.69 68.3) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.48,
    y: 198.38,
    width: 13.42,
    height: 1.71,
    transform: "translate(-113.45 202.1) rotate(-60.03)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.03,
    y: 202.63,
    width: 1.71,
    height: 13.42,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.72,
    y: 192.53,
    width: 1.71,
    height: 13.42,
    transform: "translate(-73.68 123.48) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.32,
    y: 164.93,
    width: 1.71,
    height: 13.42,
    transform: "translate(-38.06 277.35) rotate(-60)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.57,
    y: 133.09,
    width: 13.42,
    height: 1.71,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.47,
    y: 95.39,
    width: 13.42,
    height: 1.71,
    transform: "translate(-18.49 123.5) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.87,
    y: 67.79,
    width: 13.42,
    height: 1.71,
    transform: "translate(37.42 202.06) rotate(-60.03)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.17 57.91 160.08 139.92 151.68 139.81 154.89 57.89 157.17 57.91",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.25 105.34 153.08 140.56 149.07 133.18 207.16 103.34 208.25 105.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.88,
    cy: 133.94,
    r: 2.87,
    style: {
      fill: "#FFC727"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.71,314.72c5.15,2.57,10.24,5.24,15.32,7.92s10.13,5.43,15.2,8.15,10.08,5.53,15.09,8.35l7.5,4.25c2.48,1.45,5,2.87,7.45,4.35-2.58-1.28-5.12-2.61-7.69-3.92l-7.63-4c-5.09-2.68-10.13-5.44-15.2-8.15s-10.07-5.54-15.08-8.36S354.66,317.65,349.71,314.72Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,314.72c-4.59,2.64-9.24,5.19-13.89,7.73s-9.34,5-14,7.49-9.39,4.89-14.12,7.29l-7.1,3.57c-2.38,1.15-4.75,2.34-7.15,3.47,2.29-1.33,4.62-2.6,6.92-3.91l7-3.82c4.66-2.53,9.35-5,14-7.49s9.4-4.89,14.12-7.28S401.21,317,406,314.72Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.55,314.72c5.15,2.57,10.24,5.24,15.32,7.92s10.13,5.43,15.2,8.15,10.08,5.53,15.08,8.35l7.51,4.25c2.48,1.45,5,2.87,7.45,4.35-2.58-1.28-5.12-2.61-7.69-3.92l-7.63-4c-5.09-2.68-10.13-5.44-15.2-8.15s-10.08-5.54-15.08-8.36S297.5,317.65,292.55,314.72Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.83,314.72c-4.59,2.64-9.24,5.19-13.89,7.73s-9.35,5-14,7.49-9.39,4.89-14.12,7.29l-7.1,3.57c-2.38,1.15-4.75,2.34-7.15,3.47,2.29-1.33,4.62-2.6,6.92-3.91l7-3.82c4.66-2.53,9.35-5,14-7.49s9.4-4.89,14.12-7.28S344.05,317,348.83,314.72Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303 306.81 299.97 324.97 279.46 435.76 276.15 435.76 291.07 324.97 293.27 306.81 303 306.81",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.27 306.81 303 306.81 299.97 324.97 291.07 324.97 293.27 306.81",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.43 435.76 364.12 435.76 343.61 324.97 340.58 306.81 350.31 306.81 352.51 324.97 367.43 435.76",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.31 306.81 352.51 324.97 343.61 324.97 340.58 306.81 350.31 306.81",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.97 435.76 425.66 435.76 405.14 324.97 402.11 306.81 411.84 306.81 414.05 324.97 428.97 435.76",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.05 324.97 405.14 324.97 402.11 306.81 411.84 306.81 414.05 324.97",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.72 315.34 273.39 315.34 273.39 299.5 329.66 299.5 348.58 177.75 417.99 177.75 423.72 315.34",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.72 315.34 415.53 315.34 410.19 177.75 417.99 177.75 423.72 315.34",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.29,212.72c7.28,6.69,18.41,8,27.85,7.21,9.63-.82,20.22-3.34,28.17-9.07a23.48,23.48,0,0,0,8.18-9.86c1.77-4.3,1.43-8.48-1.68-11.79-2.5-2.67-7.3-4.12-7.72-6.85s1.46-5.22,1.68-7.93c.36-4.64-2.55-7.63-6.1-10.07-8.41-5.79-7.79-15.2-13.62-23.1-3.31-4.49-11.95-12.4-24.34-6.32-4.72,2.31-7.42,7.37-8.72,12.38-1.53,5.89,1.26,12.91-.83,18.67-1.79,4.91-5.31,6.18-7,11.3-.71,2.22-.84,4.7,2.08,9.24,1.06,1.64,2.31,4.2,1.9,6.4-.57,3.06-3.78,4.91-4.44,8.11C313.83,205.44,316.08,209.77,319.29,212.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.76,202.59c4.36-1.42,5.33-7.93,2-10.67-2.1-1.74-4.93-2.26-7-4-3.46-2.85-1.27-6.23-.17-9.71,2.39-7.55-3.06-11.57-8.72-15.14-4.3-2.72-5.64-6.37-6.63-11.19,0-.07.1-.1.12,0,.9,3.52,1.93,6.95,4.83,9.37,2.36,2,5.27,3.11,7.58,5.17,3.87,3.45,4.92,7.68,3.31,12.54-.46,1.4-1.49,3.06-1.54,4.52-.11,3.43,2.64,4.77,5.25,6,2,1,4.23,2.08,5.25,4.2,1.55,3.21-.74,8.25-4.14,9.14C380.69,202.9,380.59,202.65,380.76,202.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.86,206.37c2.48-2.1,5.22-4.07,6.38-7.25,1.71-4.7-1.77-7.5-5-10.14-1.4-1.13-2.6-2.29-2.83-4.16-.33-2.79,1.31-5.44,1.22-8.25-.23-6.7-7.28-9.68-11.27-14s-6-10-8.14-15.53c0-.12.14-.19.18-.07,2.72,7,5.91,13.54,11.88,18.36,4.17,3.36,8.62,7,7.85,12.93-.19,1.45-.81,2.85-1,4.29-.31,2.88.71,4.55,2.82,6.25s4.35,3.26,5.09,5.9c1.45,5.13-3.18,9.41-6.91,12.05A.24.24,0,0,1,378.86,206.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.29,199.58c1.69-3.53,5-5.68,3.29-10.06-1.15-3-3.24-5.24-3.16-8.65a12.09,12.09,0,0,1,3.21-7.37c2.23-2.72,4.8-5,6.21-8.33,1.53-3.6,1.84-7.57,2.19-11.41,0-.08.13-.07.13,0-.18,5.17-.56,10.51-3.7,14.88-1.64,2.27-3.78,4.15-5.39,6.44-2.9,4.13-2.22,8,0,12.2,1,1.93,2,3.87,1.41,6.1s-2.32,3.84-3.4,5.8c-4.58,8.34,5.92,16.2,13.52,16.32.34,0,.39.53,0,.53-5.66.08-12.35-4-14.49-9.26A8.85,8.85,0,0,1,313.29,199.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.2,203.49c-.5-3.32,1.23-5.49,2.37-8.34,1.79-4.49-1.46-8.07-2.5-12.32a10.78,10.78,0,0,1,1.51-8.2c2-3.36,4.78-6,6.23-9.71a21.82,21.82,0,0,0,.9-12.48c0-.08.1-.08.12,0A20.68,20.68,0,0,1,320.22,169c-2,3.09-5,5.84-5.77,9.66-.82,4,1.68,7.2,2.84,10.9a8.57,8.57,0,0,1-.5,6.65,17.44,17.44,0,0,0-2,4.88,10.42,10.42,0,0,0,1.9,7c4.15,6.43,12.14,9.55,19.23,9.5.25,0,.3.4,0,.4a24.35,24.35,0,0,1-17.43-6.83A14,14,0,0,1,314.2,203.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.3,436.14c2.67.92,79.21,1.46,82.14-.36,1.11-.68,3.25-31.3,2.62-34.29-2.12-10.15-12.25-40.91-12.25-40.91l-51.2-.51L304.27,401l.17,9S275,422.86,272,425.21,266.63,435.23,269.3,436.14Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.06,436.25c2.69.92,79.65,1.47,82.6-.36,1.37-.85,2.17-17.21,2.64-34.49l-50.06-.5.16,9s-29.56,13-32.58,15.33S266.38,435.33,269.06,436.25Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.19,433.18c12.9-.22,65,.09,77.75.85.1,0,.1.07,0,.08-12.79.5-64.85-.23-77.75-.72C269.92,433.38,269.92,433.18,270.19,433.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.6,407.05c5.09-.91,11.29-.09,15.14,3.56.15.14-.05.35-.21.3a70.94,70.94,0,0,0-14.91-3.22A.32.32,0,0,1,302.6,407.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.92,409.23c5.08-.91,11.29-.09,15.14,3.56.15.14-.05.35-.22.3a71.34,71.34,0,0,0-14.9-3.22A.32.32,0,0,1,298.92,409.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.24,411.41c5.08-.91,11.29-.08,15.14,3.56.15.14-.05.35-.22.3a71.32,71.32,0,0,0-14.9-3.21A.33.33,0,0,1,295.24,411.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.56,413.6c5.08-.92,11.29-.09,15.14,3.55.15.15-.05.36-.22.3a71.32,71.32,0,0,0-14.9-3.21A.32.32,0,0,1,291.56,413.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,402.49c3.57,2.82,8.24,4,12.42,5.57.43.17.78-.24.8-.63a.13.13,0,0,0,.12-.18,27,27,0,0,0-7.73-11.68c-2.11-1.8-5.82-3.06-7.83-.33S293.45,400.84,295.53,402.49Zm-1.26-4.1c-.86-5.57,5.1-2.61,6.6-1.22a27.45,27.45,0,0,1,2.67,2.93,79,79,0,0,1,4.67,6.72c-2-.9-4.07-1.62-6.11-2.45C299.67,403.38,294.74,401.47,294.27,398.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.88,399.64c-1.21-3.18-5.12-3-7.63-1.8A27.1,27.1,0,0,0,307.66,407a.14.14,0,0,0,.06.21.64.64,0,0,0,.61.82c4.45-.4,9.26-.28,13.46-2C324.24,405,327,402.64,325.88,399.64ZM315,406.06c-2.18.25-4.37.39-6.54.72a80.74,80.74,0,0,1,6.3-5.22,30,30,0,0,1,3.36-2.1c1.82-.93,8.36-2.19,6,3C322.82,405.25,317.56,405.76,315,406.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.89,284.4c-9.39,9.33-22.47,15.22-33.6,21-9.56,4.92-17.67,9.72-20.74,16.48-2.69,6,19.63,71.81,19.63,71.81L300,398.59s-23.57-64.4-17.67-92.12c1-4.55,5.51-10.44,12-16.87,23.19-22.9,71.27-52.66,71.27-52.66h29.53S407.38,266,388.89,284.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.8,243.37c-.12-1.34-.26-2.68-.39-4,0-.13-.22-.13-.2,0,1.22,10.76,2.23,22.56-2.84,32.55C383.49,281.52,373.71,287.3,365,293L349.2,303.5l-7.92,5.22a74.83,74.83,0,0,0-6.29,4.43,18.53,18.53,0,0,0-4.59,5.19,13.06,13.06,0,0,0-1.5,7.41c1.29,17.3,18.42,63.12,18.82,64.6a.3.3,0,0,0,.57-.17c-3.72-11.54-13.75-37.22-18.24-60.38-.57-3-1-6.11-.07-9.06a14.27,14.27,0,0,1,4.12-6.07,44.26,44.26,0,0,1,5.87-4.4l8-5.32,15.69-10.37c8.57-5.67,18.23-11.17,23.8-20.13C393.31,265.13,392.75,253.87,391.8,243.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.89,284.4c-9.39,9.33-22.47,15.22-33.6,21-19.67-5.16-44.51-11.61-61-15.76,23.19-22.9,71.27-52.66,71.27-52.66h29.53S407.38,266,388.89,284.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,397.37c2.28,1.66,75.19,24.95,78.53,24.08,1.27-.32,5.28-10.74,9.77-23.47,1-2.75,2-5.59,2.94-8.49,6.41-18.78,12.77-38.86,12.77-38.86l-48.73-15.72L212.84,374.2l-2.51,8.63s-31.91,3.57-35.47,4.92S166.72,395.7,169,397.37Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.74,397.4c2.29,1.68,75.61,25.09,79,24.22,1.55-.4,7.18-15.79,12.78-32.14l-47.66-15.37-2.53,8.67s-32.08,3.59-35.66,4.94S166.45,395.73,168.74,397.4Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.73,394.8c12.38,3.63,62,19.41,74,23.94.1,0,.08.1,0,.07-12.36-3.32-61.85-19.51-74-23.8C170.4,394.91,170.46,394.73,170.73,394.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.44,379.5c5.13.64,10.81,3.27,13.4,7.9.1.18-.15.32-.3.22a71.69,71.69,0,0,0-13.27-7.51A.32.32,0,0,1,209.44,379.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.28,380.49c5.12.64,10.8,3.27,13.4,7.9.1.17-.16.31-.3.22a71.45,71.45,0,0,0-13.28-7.51A.32.32,0,0,1,205.28,380.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.12,381.47c5.12.65,10.8,3.28,13.39,7.9.11.18-.15.32-.29.22a72,72,0,0,0-13.28-7.5A.33.33,0,0,1,201.12,381.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,382.46c5.13.64,10.81,3.28,13.4,7.9.1.18-.15.32-.3.22a71.32,71.32,0,0,0-13.27-7.5A.33.33,0,0,1,197,382.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.05,373c2.57,3.75,6.68,6.26,10.2,9a.62.62,0,0,0,.95-.36.14.14,0,0,0,.17-.14,27.12,27.12,0,0,0-3.91-13.45c-1.48-2.34-4.64-4.65-7.38-2.64S202.55,370.85,204.05,373Zm0-4.29c.84-5.58,5.65-1,6.67.8a27.91,27.91,0,0,1,1.68,3.59,81.31,81.31,0,0,1,2.46,7.81c-1.65-1.46-3.41-2.77-5.11-4.16C207.74,375.12,203.6,371.83,204.06,368.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.87,379.34c-.21-3.39-4-4.34-6.75-4A27.14,27.14,0,0,0,214.28,381a.14.14,0,0,0,0,.22.63.63,0,0,0,.33,1c4.37.94,8.93,2.49,13.46,2.07C230.71,384,234.06,382.55,233.87,379.34Zm-12.34,2.89c-2.16-.42-4.29-.93-6.46-1.26a78.09,78.09,0,0,1,7.57-3.11,28.42,28.42,0,0,1,3.83-1c2-.35,8.63.4,4.88,4.62C229.28,383.79,224.1,382.72,221.53,382.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.73,369.55l54,15.89,16.74-61.63c1.46-20.37,5.13-30.25,17.11-34,20.4-6.32,70.24,17,92.81,1.36,18.33-12.72,3.71-54.28,3.71-54.28h-53s-6.4,7.79-7.58,12.37c0,0-65.63-5.06-80.32,13.56C234.57,287.82,210.73,369.55,210.73,369.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.78,288.92a29,29,0,0,0-9.42.73,21.53,21.53,0,0,0-8,4.1,20.13,20.13,0,0,0-5.4,6.82c-1.5,3.09-2,6.59-2.53,10-.29,2-.48,4-.59,6s-.19,4.78-.19,6.49c0,.15.2.16.2,0a40.11,40.11,0,0,1,.45-5.37c.22-1.69.52-3.37.81-5.05a56.43,56.43,0,0,1,2.33-9.85,21.28,21.28,0,0,1,11.89-12.22,22,22,0,0,1,5.12-1.38,35.4,35.4,0,0,1,5.35-.17S307.82,288.92,307.78,288.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.75,257a23.33,23.33,0,0,1-5.31-1.9,15.11,15.11,0,0,1-4.51-3.17,10,10,0,0,1-1.91-4.37c-.21-.86-.33-1.74-.47-2.61s-.39-1.91-.46-2.87c0-.12-.21-.11-.2,0,.45,3.62-.57,7.66,2.13,10.74a13.17,13.17,0,0,0,4.9,3.15,17.07,17.07,0,0,0,5.78,1.4A.19.19,0,0,0,383.75,257Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.67,248.65q-.72-2.93-1.68-5.78c0-.12-.24-.07-.19.06a69.27,69.27,0,0,1,3.36,24.59,47.78,47.78,0,0,1-1.59,11.67,14.36,14.36,0,0,1-6.57,8.67,31.69,31.69,0,0,1-10.72,3.35,74.88,74.88,0,0,1-12.69.89c-8.65-.08-17.24-1.25-25.81-2.26-8.31-1-16.62-2.13-24.95-2.88-6.82-.61-14.09-.68-20.4,2.34-6,2.89-9.92,8.4-12.48,14.39-2.88,6.77-4.51,14.07-6.46,21.14-2.32,8.43-14.3,54.4-14.48,56.37,0,.19.27.18.29,0,.42-4.32,10.79-42.34,13.12-50.83l3.51-12.72c.93-3.39,1.85-6.79,3-10.11,2.22-6.33,5.48-12.68,11.25-16.46,6.15-4,13.81-4.33,20.92-3.81,4,.28,8,.82,12,1.29l13.13,1.56c8.38,1,16.77,2.17,25.21,2.43a80.86,80.86,0,0,0,12.64-.51,41.69,41.69,0,0,0,11.07-2.64,15,15,0,0,0,7.5-6.36c1.76-3.15,2.36-6.8,2.75-10.33A69.56,69.56,0,0,0,393.67,248.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.78,187.62c-7,23-12.86,40.85-19.64,45-5.47,3.37-39.47,9.65-46.08,10-2.61.14-4.78.22-6.32.28-3.8.13-9.31-25.14-6.53-28.12.64-.68,3.16-1.15,6.69-1.49,11.87-1.15,35.16-.83,36.59-2.11s9.26-11.06,19.82-23.83c7.28-8.82,13.11-11.31,15.39-8.73C356,180.11,356.13,183.18,354.78,187.62Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.05,242.66a99.63,99.63,0,0,1-12.33,4.15c-3.34.73-13,2.59-14.2-1-.8-2.45,4.76-4.22,8.67-5.55,2.05-.7,4.66-2.64,4.15-4-.88-2.32-6.18-.39-9.71,1.36-6.8,3.38-16,9.66-19.78,6.07-1.43-1.36.48-3.53,3.2-5.61-4.35,2.34-8.94,4.2-10.59,2.75-.94-.82-.92-1.86-.29-3a3,3,0,0,1-3.19-.72c-1.26-1.51-.46-3.56,1.16-5.61a1.63,1.63,0,0,1-1.18-.89c-2.58-4.57,12.62-16.2,17.68-17.05,14.86-2.52,30.34-.23,30.34-.23C288.42,218.31,289.07,242.65,289.05,242.66Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.43,227.61a23.83,23.83,0,0,0-10,3.11c-3.57,2.12-6.49,5.15-9.82,7.59-.09.07,0,.21.1.14,1.58-1.27,3.29-2.39,4.91-3.6s3.15-2.43,4.82-3.49a23.55,23.55,0,0,1,10-3.69S268.47,227.6,268.43,227.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.11,221.22a59.08,59.08,0,0,0-11.61,3.19c-4,1.73-7.31,4.78-10.52,7.7q-2.88,2.64-5.66,5.4c-.08.08,0,.21.11.14q4.89-4.54,10-8.78A31.27,31.27,0,0,1,259.26,223c2.26-.69,4.56-1.21,6.86-1.73A0,0,0,1,0,266.11,221.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.36,215.52c-3.78.52-7.09,1-10.53,2.75-4.55,2.36-9.07,6.55-10.66,8-1.75,1.64-3.45,3.34-5.12,5.06-.07.07,0,.19.12.12A125.42,125.42,0,0,1,248.31,221a25,25,0,0,1,6.65-3.72,44.66,44.66,0,0,1,7.41-1.68S262.38,215.52,262.36,215.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.9,183.78c-.88,6.53-5.85,19.07-5.85,19.07l-24.46-2.79s13.14-16.82,23.05-23C353.62,174.59,357.8,177.18,356.9,183.78Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.26,199.52c-3.61-.65-7.21-1.25-10.85-1.69-1.82-.22-3.63-.41-5.45-.58s-3.66-.14-5.47-.33c-.1,0-.11.15,0,.16,1.81.09,3.64.44,5.45.63s3.63.4,5.45.61c3.62.43,7.25.85,10.87,1.36C351.35,199.69,351.35,199.54,351.26,199.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.88,185.11a8.54,8.54,0,0,1,3.61-1.92,7.78,7.78,0,0,1-1.69,1.18A8,8,0,0,1,347.88,185.11Zm-3.16,11.57a8.08,8.08,0,0,0-2-.36,7.52,7.52,0,0,0,1.88.84,7.65,7.65,0,0,0,2,.36A7.52,7.52,0,0,0,344.72,196.68Zm-5.06-10.4a7.58,7.58,0,0,0-.36,2,7.49,7.49,0,0,0,.83-1.88,7.58,7.58,0,0,0,.36-2A8.11,8.11,0,0,0,339.66,186.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.9,183.78c0,.36-.1.75-.18,1.13s-.12.61-.2.94a113.21,113.21,0,0,1-5.47,17l-1-.11-.95-.11-7.69-.88-1.14-.12-7.67-.87-1-.12-2.82-.32,20.82-23.26C354,175.34,357.78,177.18,356.9,183.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.3,249.78s23.24,3.59,66.15-3.6c0,0-21.2-52.58-36-66-6.72-6.12-12.69-4.63-17.48,0-1.19,1.16-15.45,22.56-16.24,29.69-.69,6.3,4.9,12.78,4.9,12.78Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.92,224.86a7.78,7.78,0,0,1-1.18-1.69,7.29,7.29,0,0,1-.74-1.92,7.78,7.78,0,0,1,1.18,1.69A8,8,0,0,1,375.92,224.86Zm-21.18-23.55a7.5,7.5,0,0,0-1.19-1.69,8,8,0,0,0,.74,1.92,7.78,7.78,0,0,0,1.18,1.69A7.4,7.4,0,0,0,354.74,201.31Zm36.8,41.37a8,8,0,0,0-1.18-1.68,8,8,0,0,0,.74,1.92,7.78,7.78,0,0,0,1.18,1.69A7.87,7.87,0,0,0,391.54,242.68ZM349,230.55a7.78,7.78,0,0,0-1.18-1.69,8,8,0,0,0,.74,1.92,7.78,7.78,0,0,0,1.18,1.69A7.8,7.8,0,0,0,349,230.55Zm9.46-51.63a7.15,7.15,0,0,0-1.18-1.69,8.54,8.54,0,0,0,1.92,3.61A7.08,7.08,0,0,0,358.45,178.92ZM361,222.38a8,8,0,0,0,1.69-1.18,7.87,7.87,0,0,0-1.93.74,8,8,0,0,0-1.69,1.18A7.87,7.87,0,0,0,361,222.38Zm-22.58-9.12a8,8,0,0,0,1.68-1.18,7.21,7.21,0,0,0-1.92.74,7.78,7.78,0,0,0-1.69,1.18A7.87,7.87,0,0,0,338.45,213.26Zm11.35-28.89a7.78,7.78,0,0,0,1.69-1.18,8.54,8.54,0,0,0-3.61,1.92A8,8,0,0,0,349.8,184.37Zm3.81,60.79A7.78,7.78,0,0,0,355.3,244a8.54,8.54,0,0,0-3.61,1.92A8,8,0,0,0,353.61,245.16Zm19.88-48.89a8,8,0,0,0,1.68-1.18,8.54,8.54,0,0,0-3.61,1.92A7.87,7.87,0,0,0,373.49,196.27Zm7.11,40.9a7.78,7.78,0,0,0,1.69-1.18,7.08,7.08,0,0,0-1.92.74,7.78,7.78,0,0,0-1.69,1.18A8,8,0,0,0,380.6,237.17Zm-14.9-4.34a7.65,7.65,0,0,0-2-.36,7.52,7.52,0,0,0,1.88.84,8.08,8.08,0,0,0,2,.36A7.52,7.52,0,0,0,365.7,232.83Zm-28.12-7.1a7.65,7.65,0,0,0-2-.36,7.52,7.52,0,0,0,1.88.84,8.08,8.08,0,0,0,2,.36A7.52,7.52,0,0,0,337.58,225.73Zm28.94-18.15a7.58,7.58,0,0,0-2-.36,7.75,7.75,0,0,0,1.89.84,8,8,0,0,0,2,.36A7.75,7.75,0,0,0,366.52,207.58Zm-21.8-10.9a8.08,8.08,0,0,0-2-.36,7.52,7.52,0,0,0,1.88.84,7.65,7.65,0,0,0,2,.36A7.52,7.52,0,0,0,344.72,196.68Zm43.49,29.71a7.58,7.58,0,0,0-2-.36,7.86,7.86,0,0,0,1.88.84,8.16,8.16,0,0,0,2,.36A7.52,7.52,0,0,0,388.21,226.39Zm-7.94-16.15a7.65,7.65,0,0,0-.36,2,7.52,7.52,0,0,0,.84-1.88,8,8,0,0,0,.36-2A7.68,7.68,0,0,0,380.27,210.24Zm-30.43,5.28a7.65,7.65,0,0,0-.36,2,7.52,7.52,0,0,0,.84-1.88,7.64,7.64,0,0,0,.35-2A7.87,7.87,0,0,0,349.84,215.52ZM340.42,243a7.58,7.58,0,0,0-.36,2,7.75,7.75,0,0,0,.84-1.89,8,8,0,0,0,.36-2A7.52,7.52,0,0,0,340.42,243Zm29.91,2a7.65,7.65,0,0,0-.36,2,7.49,7.49,0,0,0,.83-1.88,7.58,7.58,0,0,0,.36-2A8.23,8.23,0,0,0,370.33,245Zm-7.5-55.41a7.58,7.58,0,0,0-.36,2,7.86,7.86,0,0,0,.84-1.88,8.16,8.16,0,0,0,.36-2A7.52,7.52,0,0,0,362.83,189.58ZM334.27,202.4a7.58,7.58,0,0,0-.36,2,7.75,7.75,0,0,0,.84-1.89,7.58,7.58,0,0,0,.36-2A7.75,7.75,0,0,0,334.27,202.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.84,178.08c0,1.2-3.37,10-8.59,11.1-1.7.37-4.13-8.81-4.13-8.81l-.33-.64-4.68-8.92,9.23-10.15,1.36-1.38s1.12,2.52,2.48,5.68l.19.45c.08.18.16.34.23.51.21.47.42,1,.62,1.43s.31.73.46,1.12.3.77.46,1.15A65,65,0,0,1,355.84,178.08Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.18,165a20.2,20.2,0,0,1-8.39,14.77l-4.68-8.92,9.23-10.15,1.36-1.38S349.82,161.8,351.18,165Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.82,158.94c2,17.56,12.73,18.36,16.52,17.93,3.44-.4,15.09-2.17,14.93-19.84s-8.95-22.31-16.86-21.83S318.84,141.37,320.82,158.94Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,155.63c.4-.11.76-.27,1.15-.41a2,2,0,0,0,1.09-.65.62.62,0,0,0-.1-.76,1.55,1.55,0,0,0-1.57-.15,2.28,2.28,0,0,0-1.32,1A.68.68,0,0,0,323,155.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,154a9.87,9.87,0,0,1-1.22-.09,2,2,0,0,1-1.23-.33.63.63,0,0,1-.1-.76,1.57,1.57,0,0,1,1.48-.56,2.24,2.24,0,0,1,1.53.61A.67.67,0,0,1,335,154Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.77,158.64s.1,0,.11.09c.09,1.2.4,2.56,1.53,2.84,0,0,0,.07,0,.07C333.06,161.6,332.67,159.79,332.77,158.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.7,157.27c1.91-.36,2.49,3.48.72,3.81S332.1,157.57,333.7,157.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.48,157.36c.37.16.76.5,1.17.48s.77-.48,1-.92c0,0,.06,0,.07,0a1.42,1.42,0,0,1-.82,1.76c-.71.21-1.32-.37-1.62-1.08C334.25,157.51,334.34,157.29,334.48,157.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.12,159.39s-.09.07-.08.12c.23,1.18.29,2.57-.72,3.14,0,0,0,.07,0,.06C326.62,162.32,326.52,160.47,326.12,159.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.86,158.31c-1.94.16-1.47,4,.32,3.87S326.48,158.18,324.86,158.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.09,158.66c-.28.25-.54.65-.9.72s-.78-.3-1.1-.67c0,0-.06,0-.06,0,.07.74.41,1.48,1.13,1.54s1.06-.64,1.15-1.4C324.33,158.76,324.2,158.57,324.09,158.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.39,168.38c-.23.34-.44.77-.86.89a3.15,3.15,0,0,1-1.33,0,0,0,0,0,0,0,.07,1.62,1.62,0,0,0,1.63.34,1.28,1.28,0,0,0,.72-1.22C334.52,168.34,334.42,168.34,334.39,168.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.8,164.77s0,1.81.12,2.65c0,.08.22.09.51.07h0a4,4,0,0,0,3.67-2c.05-.09-.07-.16-.14-.09a6.14,6.14,0,0,1-3.5,1.55c-.09-.23.1-3.11,0-3.1a7,7,0,0,0-1.85.7c-.12-3.78.38-7.55.21-11.31,0-.14-.21-.15-.23,0a60.78,60.78,0,0,0-.74,12.17C326.85,165.83,328.49,165,328.8,164.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.49,167.07a5,5,0,0,0,2.07,1.39,2.19,2.19,0,0,0,1.34,0c1-.31.92-1.2.69-1.95a5.57,5.57,0,0,0-.51-1.14A6.37,6.37,0,0,1,329.49,167.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.56,168.46a2.19,2.19,0,0,0,1.34,0c1-.31.92-1.2.69-1.95A2.27,2.27,0,0,0,331.56,168.46Z",
    style: {
      fill: "#ff9cbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.12,158.53c-1.92,0-7.31-4.86-8.17-14.1,0,0,1.34,8.25,2.06,9.42s-3-2.76-3.82-10.2a30.26,30.26,0,0,1-7.35,4.56c-3.45,1.25-5.61,1.39-5.88,1.15s4.79-2.27,6.07-4c0,0-9,5.07-13.34,5.73-.49.08-1.88-10.15,4.47-15s17.29-1,20.35,1.56c0,0,3.37.22,7.38,4.89S353.2,158.5,351.12,158.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.55,164.18a5.56,5.56,0,0,1-5.53-5.57h0a5.55,5.55,0,1,1,6.9,5.4A5.65,5.65,0,0,1,335.55,164.18Zm-4.79-5.57a4.81,4.81,0,1,0,4.82-4.79,4.54,4.54,0,0,0-1.18.15A4.8,4.8,0,0,0,330.76,158.61Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.92,165.65c-2.25.29-4.41-1.94-4.8-5a6.59,6.59,0,0,1,.66-4,3.46,3.46,0,0,1,5.87-.76,6.66,6.66,0,0,1,1.66,3.7c.37,2.87-1,5.44-3,6ZM320.43,157a5.86,5.86,0,0,0-.58,3.54c.34,2.63,2.13,4.57,4,4.33s3.08-2.57,2.74-5.2a5.94,5.94,0,0,0-1.46-3.28,3,3,0,0,0-2.52-1.05l-.27.05A3.07,3.07,0,0,0,320.43,157Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.28,159.22l.4-.62c-.92-.6-3-1.29-4.13.32l.6.44C328.19,157.91,330.2,159.17,330.28,159.22Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,157.46l.61-.43c-.2-.28-2-2.77-3.65-2.83s-11.31,2.16-11.72,2.25l.16.73c2.8-.64,10.32-2.28,11.54-2.24S354.5,156.77,355,157.46Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,163.5a4.78,4.78,0,0,1-.76.37,2.89,2.89,0,0,1-.82.18,2.43,2.43,0,0,1-1.06-.12,3.35,3.35,0,0,1-.76-.37,3.42,3.42,0,0,1-.85-.84l0-4.82s2.69-6.18,5.41-5.32S355.71,161.85,353,163.5Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.81,155c.05,0,.07.05,0,.07-1.86,1.23-2.55,3.32-2.9,5.41a1.65,1.65,0,0,1,2.33-.93c.06,0,0,.12,0,.12a1.84,1.84,0,0,0-1.86,1,8.62,8.62,0,0,0-.62,1.79c-.06.2-.41.17-.38-.05v0C349.83,159.8,351.1,155.8,353.81,155Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.65,162.82a.82.82,0,1,1-.82-.82A.82.82,0,0,1,352.65,162.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.06,161.27a.58.58,0,1,1-.58-.58A.58.58,0,0,1,354.06,161.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.62,183.09c13.14,17.89,30.84,48.09,22.59,54.59-13.56,10.67-52.67,16.19-61.63,17.09-3.87.38-11.09-25-8.45-28.21s43.9-4.68,44.24-7.2c.19-1.43-2.91-13.8-6.62-29.19C352.46,172.42,362.85,178,366.62,183.09Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.93,224.62s-11.83-.33-19.57-.18c-4.32.08-11.71.89-14.86,2.4-4.7,2.26-22.93,14.72-20,19.21,2.65,4.06,17-8.64,17-8.64S272.88,249,277,253.25s18.34-12.19,18.34-12.19-15.73,12.21-10.81,16c3.72,2.85,17.47-11.36,17.47-11.36s-13.44,10.59-9.75,13.68c4.09,3.42,17.6-8.9,17.6-8.9,10.72,6.28,18.4,4.89,23.74,3.25C334.86,253.31,325.93,224.62,325.93,224.62Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.58,233.08c-1.88,1.29-3.79,2.58-5.55,4s-3.46,3-5.08,4.57a39.81,39.81,0,0,0-5.68,6.86c3.21-4.22,9.42-9.51,11.18-11s3.43-3,5.18-4.44C293.68,233.11,293.62,233.05,293.58,233.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.93,239.33c-2.32,1.74-4.7,3.4-6.95,5.25s-4.2,3.79-6.3,5.78c-.17.16,0,.19.14,0,2.18-1.9,4.35-3.5,6.55-5.38s4.34-3.85,6.61-5.64A0,0,0,0,0,298.93,239.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.49,243.86a64.73,64.73,0,0,0-10,8.85c-.15.16,0,.18.2,0,3.27-3,5.81-5.38,9.9-8.75C304.64,243.94,304.57,243.81,304.49,243.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.78,223.51c-1.66,0-5.17.56-9.06.65-8.75.18-21.11-.11-25.52,0-11.92.36-19.34,9-22.74,12a42,42,0,0,0-5.53,6c-.85,1.19-1.68,2.88-.6,4.24,1.31,1.65,6.4,0,11.75-4.61.19-.17.07-.28-.13-.13-7.48,5.82-10.4,5.08-11.15,4-.48-.67,0-1.81.48-2.67a17.74,17.74,0,0,1,2.68-3.42,72.83,72.83,0,0,1,11.34-9.54,28.58,28.58,0,0,1,15-5.29c3.84-.24,15.62.11,24.44-.15,3.86-.12,7.36-.81,9-.94C334.92,223.7,334.9,223.51,334.78,223.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.41,205.8l-25.11-.64s-2.7-12.33-3.24-19.36c-.71-9.31,2.58-11.76,10.75-3.74C371.27,187.43,383.41,205.8,383.41,205.8Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.19,180.84a8.54,8.54,0,0,1-1.92-3.61,8.54,8.54,0,0,1,1.92,3.61Zm14.3,15.43a8,8,0,0,0,1.68-1.18,8.54,8.54,0,0,0-3.61,1.92A7.87,7.87,0,0,0,373.49,196.27Zm-10.66-6.69a7.58,7.58,0,0,0-.36,2,7.86,7.86,0,0,0,.84-1.88,8.16,8.16,0,0,0,.36-2A7.52,7.52,0,0,0,362.83,189.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.37,205.25c-.27-.06-2.85-.21-3-.17-.28-1.46-.54-2.92-.84-4.37-.15-.73-.31-1.46-.48-2.18s-.37-1.71-.53-2.41c0-.11-.17-.09-.16,0,.13.94.25,1.63.37,2.44s.22,1.45.36,2.17c.28,1.52.52,3.15.88,4.66a27.15,27.15,0,0,0,3.44-.07A0,0,0,0,0,361.37,205.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.92,203.35c-3.65-.34-7.29-.64-10.95-.77-1.83-.06-3.65-.1-5.48-.11s-3.66.17-5.48.13a.08.08,0,0,0,0,.16c1.82-.06,3.67.13,5.49.17l5.48.14c3.65.12,7.3.23,10.95.44C381,203.51,381,203.36,380.92,203.35Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-141"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "260.67 253.13 316.06 253.13 316.06 248.83 260.67 247.04 260.67 253.13",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.13,253.06h36.55c3.11,0-1.4-8.88-12.78-12.29S213.54,249.73,217.13,253.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.47,253.06a26.86,26.86,0,0,0-2.38-5.37,14.86,14.86,0,0,0-1.7-2.32,19,19,0,0,0-2.15-2,7.31,7.31,0,0,1,2.69,1.47,9.1,9.1,0,0,1,2,2.36,11.16,11.16,0,0,1,1.21,2.85A9.19,9.19,0,0,1,231.47,253.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.14,244.61c-1.92,1.24-3.84,2.37-5.64,3.66a18.88,18.88,0,0,0-2.54,2.08,7,7,0,0,0-1.83,2.71,5,5,0,0,1,1.25-3.23,11.94,11.94,0,0,1,2.54-2.38,19.68,19.68,0,0,1,3-1.72A16.13,16.13,0,0,1,227.14,244.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.91 235.87 279.74 235.87 265.62 169.73 176.78 169.73 190.91 235.87",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.63 235.87 276.46 235.87 262.33 169.73 173.5 169.73 187.63 235.87",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.54 212.16 237.62 212.16 234.46 197.32 232.37 197.32 235.54 212.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.43 212.16 233.51 212.16 230.35 197.32 228.26 197.32 231.43 212.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.32 212.16 229.4 212.16 226.24 197.32 224.15 197.32 227.32 212.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.21 212.16 225.29 212.16 222.13 197.32 220.04 197.32 223.21 212.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.09 212.16 221.18 212.16 218.01 197.32 215.93 197.32 219.09 212.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.98 212.16 217.07 212.16 213.9 197.32 211.82 197.32 214.98 212.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.87 212.16 212.96 212.16 209.79 197.32 207.71 197.32 210.87 212.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.75 253.14 256.44 253.14 256.44 249.75 212.75 248.33 212.75 253.14",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.87 253.13 224.33 253.13 238.46 216.08 215 216.08 200.87 253.13",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.01 253.13 220.47 253.13 234.59 216.08 211.14 216.08 197.01 253.13",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-141"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.53,
    y: 253.13,
    width: 314.94,
    height: 5.73,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.03,
    y: 258.86,
    width: 299.94,
    height: 14.38,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.03,
    y: 258.86,
    width: 299.94,
    height: 7.19,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.81,
    y: 385.64,
    width: 26.88,
    height: 4.73,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.27 454.8 152.37 454.8 128.69 344.27 127.34 337.97 123.09 318.13 121.51 310.73 115.55 282.97 113.47 273.24 123.81 273.24 125.5 282.97 126.6 289.35 127.34 293.6 131.59 318.13 132.96 326.03 155.27 454.8",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.81 273.24 125.5 282.97 115.55 282.97 113.47 273.24 123.81 273.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.96 326.03 128.69 344.27 127.34 337.97 123.09 318.13 121.51 310.73 126.6 289.35 127.34 293.6 131.59 318.13 132.96 326.03",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.21 273.24 139.13 282.97 131.59 318.13 127.34 337.97 102.31 454.8 99.41 454.8 123.09 318.13 127.34 293.6 129.18 282.97 130.86 273.24 141.21 273.24",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.21 273.24 139.13 282.97 129.18 282.97 130.86 273.24 141.21 273.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.13,
    y: 385.64,
    width: 26.88,
    height: 4.73,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.59 454.8 397.68 454.8 374.01 344.27 372.66 337.97 368.4 318.13 366.82 310.73 360.87 282.97 358.78 273.24 369.13 273.24 370.81 282.97 371.92 289.35 372.66 293.6 376.9 318.13 378.27 326.03 400.59 454.8",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.13 273.24 370.81 282.97 360.87 282.97 358.78 273.24 369.13 273.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.27 326.03 374.01 344.27 372.66 337.97 368.4 318.13 366.82 310.73 371.92 289.35 372.66 293.6 376.9 318.13 378.27 326.03",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.52 273.24 384.44 282.97 376.9 318.13 372.66 337.97 347.62 454.8 344.73 454.8 368.4 318.13 372.66 293.6 374.49 282.97 376.18 273.24 386.52 273.24",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.52 273.24 384.44 282.97 374.49 282.97 376.18 273.24 386.52 273.24",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamp--inject-141"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "119.18 247.45 117.2 247.19 125.81 181.64 151.19 165.44 159.38 170.8 158.29 172.47 151.17 167.82 127.67 182.82 119.18 247.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.06,182.23a1.69,1.69,0,1,0,1.68-1.68A1.68,1.68,0,0,0,125.06,182.23Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.1,
    cy: 166.63,
    r: 1.68,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.44 173.1 162.25 185.59 157.09 179.21 153.95 175.32 162.33 165.97 166.54 168.68 173.44 173.1",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.44 173.1 162.25 185.59 157.09 179.21 166.54 168.68 173.44 173.1",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.65 179.26 170.15 201.02 157.2 184.5 171.81 168.2 189.65 179.26",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.5 253.14 104.65 253.14 106.42 244.08 131.73 244.08 133.5 253.14",
    style: {
      fill: "#FFC727"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.13,337.26a45.8,45.8,0,0,0,.89,17.57,48.87,48.87,0,0,0,2.69,7.77c1.4,3.21,2.86,6.35,2.51,9.87-.34.23.83.19.86-.15,9.4-5.35,21.46-6.33,28.69-15.08,3.43-4.15,5.16-9.4,6-14.65.89-5.72,1.13-12-.34-17.69-1.25-4.77-4-9.37-8.51-11.71s-10.68-2.2-15.55-.69C431.84,315.77,426.62,327.1,425.13,337.26Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.31,406.84c1.28-4.27,2.56-8.55,3.88-12.81,2.58-8.36,5.26-16.68,8.23-24.91q2.67-7.38,5.62-14.63a85.11,85.11,0,0,0-1.12-9.09c-.78-3.64-1.93-7.16-3-10.73a.2.2,0,0,1,.38-.13c2.11,4.92,4.87,11.2,4.93,17,2.3-5.47,4.75-10.86,7.39-16.17a69.06,69.06,0,0,0-.41-13.47.16.16,0,0,1,.32-.06,48.21,48.21,0,0,1,.92,11.89c2-4,4.14-7.93,6.41-11.81.2-.35.69,0,.51.35-3.53,6.8-6.81,13.75-9.89,20.78a45.38,45.38,0,0,1,14.74-8.53c.24-.08.41.26.17.35a54,54,0,0,0-15.94,10.56q-3.31,7.73-6.31,15.58c5.88-5.77,13.93-9.56,21.71-11.59.27-.07.34.33.08.41-9,2.71-16,7.82-22.86,14q-1.2,3.17-2.34,6.36-4.37,12.07-8.3,24.31c-1.26,3.9-2.51,7.82-3.73,11.73-1.31,4.22-2.34,8.67-4,12.74-.16.39-.86.3-.77-.17A122.82,122.82,0,0,1,420.31,406.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.9,329a23.5,23.5,0,0,1,3.39,8.44c0,.08-.11.12-.14,0a72.85,72.85,0,0,0-3.67-8.28C435.34,329,435.74,328.79,435.9,329Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.67,348.62a24.52,24.52,0,0,1,8.43-2.84c.08,0,.13.1,0,.13-1.36.57-2.78,1-4.15,1.49s-2.73,1.17-4.12,1.65A.24.24,0,0,1,452.67,348.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.39,325.06a17,17,0,0,1,2.72-1.68.14.14,0,0,1,.15.24,17,17,0,0,1-2.67,1.74C457.42,325.46,457.22,325.17,457.39,325.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.44,369.19c6.77,2,13.58,3.86,20.35,5.85.59.18,12-21.75,7.89-33.05-3.82-10.46-12.57-18.28-23-21.84-4.83-1.64-10.77-3-15.88-1.89-4.54,1-7.75,4.72-9.22,9-2,5.8-1.34,12.73-.25,18.65A32.69,32.69,0,0,0,380,361.13C383.58,365.4,388.17,367.62,393.44,369.19Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.63,348.34a90.09,90.09,0,0,0,13.27,5.23,56,56,0,0,1,8.86,3.21c-2.85-6.38-6-12.62-9.32-18.8-4.38-1.27-9-3.24-12.27-6.34a.18.18,0,0,1,.24-.28c3.61,2.55,7.59,4.08,11.58,5.8q-1.35-2.49-2.74-5c-.25-.46.38-.92.69-.47a143.58,143.58,0,0,1,9.62,16.15,73.87,73.87,0,0,0,.7-14.8.1.1,0,1,1,.19,0,49.3,49.3,0,0,1-.16,16.26c2.37,4.74,4.53,9.6,6.48,14.51.77-2.95,1.77-5.86,2.44-8.84a40.53,40.53,0,0,0,1-13c0-.13.17-.14.19,0a45.82,45.82,0,0,1-2.84,23.92c1.13,3,2.21,5.93,3.2,8.9a177.56,177.56,0,0,1,9,47,.29.29,0,0,1-.58,0,233,233,0,0,0-10.08-46.42c-2-5.9-4.23-11.63-6.71-17.26-4-1.18-8-2.78-11.91-4.14s-7.76-2.87-11-5.39C383.35,348.48,383.49,348.27,383.63,348.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.32,342c4.14,1.48,8.06,3.54,12.2,5,.19.07.08.38-.12.34-4.37-.91-8.71-2.26-12.24-5.13C377,342.1,377.17,341.92,377.32,342Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.12,333c0-.22.28-.34.34-.12,1.14,3.82,1.92,7.87.82,11.77,0,.15-.29.16-.3,0C411.79,340.74,412,336.92,411.12,333Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,324.23a10.14,10.14,0,0,1,1.79,6.49c0,.14-.24.23-.28,0-.5-2.18-1.34-4.17-2-6.29A.28.28,0,0,1,394,324.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474,378.86c-2,6.3-6.7,15-14.17,15.08-4.84,0-9.72-.53-14.57-.6-5.2-.08-10.4-.07-15.59.24-.42,0,.62-15.56,13.11-23.15,3.5-2.13,7.78-2.8,11.75-3.66a54.6,54.6,0,0,1,13.88-1.45c2.87.12,5.26.73,6.28,3.66S474.92,375.87,474,378.86Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.6,371c-3,.78-6.1,1.67-9.15,2.64a32.38,32.38,0,0,1,2.52-2.45c1.31-1.09,2.75-2,4.15-2.91.12-.08.05-.31-.1-.25a17.15,17.15,0,0,0-7.37,5.86c-3.79,1.23-7.55,2.58-11.17,4.07a42.27,42.27,0,0,0-7.16,3.76,28.69,28.69,0,0,1,2.59-4.5c1.66-2.15,3.9-3.35,6.07-4.87a.19.19,0,0,0-.2-.33A17.74,17.74,0,0,0,439,382.56,41.94,41.94,0,0,0,432,389c-8.27,9.39-14.78,21.88-14.8,34.62,0,.31.49.39.55.08a70.59,70.59,0,0,1,15.76-33.86c.59-.69,1.2-1.34,1.81-2a57.8,57.8,0,0,1,6.83-.51c2.66,0,5.3.39,7.95.61,4.36.35,9.18.41,13.11-1.79a.18.18,0,0,0-.14-.33c-8.76,3.19-18-.85-26.75,1.05a41,41,0,0,1,13-8.36l.81-.32c5.63.67,11.57,2.14,17.05.31a.13.13,0,0,0-.07-.26c-5.3,1.32-10.38-.34-15.6-.6,5.69-2.22,11.49-4,17.2-6.18C469.11,371.28,469.12,370.84,468.6,371Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.08,376.52a77.61,77.61,0,0,1-8.19.62c-.06,0-.08.1,0,.11a16.94,16.94,0,0,0,8.27-.52C471.27,376.69,471.21,376.5,471.08,376.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.58,371.12a13.4,13.4,0,0,0-4.05,2.81c-.15.13.05.39.2.27.69-.5,1.4-1,2.11-1.43a21.3,21.3,0,0,0,2-1.25C453,371.37,452.8,371,452.58,371.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.48,391.4c.09.2-.21.4-.33.18h0a.26.26,0,0,1-.19.12,125.89,125.89,0,0,1-15.26,2.67c-4.13.36-8.89.59-12.51-1.8-4.9-3.25-8.12-11.94-5.47-17.46,3.13-6.55,12.57-3,17.31-.66A34.79,34.79,0,0,1,408.48,391.4Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.14,394.43a48.56,48.56,0,0,0-9.11-6.94,31.32,31.32,0,0,0-9.24-9.42c-.18-.12-.33.16-.17.29a41.94,41.94,0,0,1,7.79,8.19,86.18,86.18,0,0,0-11.44-5.2,15.09,15.09,0,0,0-6.14-6.15c-.05,0-.11,0-.06.08a25.51,25.51,0,0,1,5.55,5.82c-2.33-.87-4.67-1.67-7-2.45-.21-.07-.29.25-.09.33,4.18,1.63,8.44,3.35,12.58,5.33a48.33,48.33,0,0,1-15.23,0,.11.11,0,0,0-.06.21,30,30,0,0,0,16.16.25,74.35,74.35,0,0,1,7.66,4.29,18.89,18.89,0,0,0-6.19.51,47.61,47.61,0,0,1-10.89,1.23c-.14,0-.17.22,0,.24,6.31,1.09,12.28-1.78,18.54-1a48.22,48.22,0,0,1,6.52,5.32,48.92,48.92,0,0,1,9.51,13.42c2.63,5.36,4.06,11,6.19,16.58a.2.2,0,0,0,.39-.1C425.54,414.26,420.1,402.21,412.14,394.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.09,379.44a7.25,7.25,0,0,0-1.62-2,6.17,6.17,0,0,0-1.86-1.39c-.06,0-.1.06-.06.1.52.59,1.24,1,1.8,1.58s1,1.23,1.59,1.79A.1.1,0,0,0,393.09,379.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.68,382.83c-.94-.23-1.93-.21-2.88-.41a27.25,27.25,0,0,1-2.8-.83.11.11,0,0,0-.08.2,9.31,9.31,0,0,0,5.76,1.34A.16.16,0,0,0,382.68,382.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.17 405.99 441.14 417.69 437.65 457.18 406.72 457.18 402.35 417.69 401.06 405.99 442.17 405.99",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.17 405.99 441.14 417.69 402.35 417.69 401.06 405.99 442.17 405.99",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 402.8,
    width: 47.23,
    height: 9.49,
    style: {
      fill: "#455a64"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtiva3);
export default __webpack_public_path__ + "static/media/protiva3.d0f059bed7788d249f547f5a119416fd.svg";
export { ForwardRef as ReactComponent };